<template>
  <div :class="$pgCTStyle.container">
    <div :class="$pgCTStyle.headerContainer">
      <div :class="$pgCTStyle.title">{{ computedTitle }}</div>


      <div :class="$pgCTStyle.headerRightCTAs">
        <PGHeaderActionButton
          v-if="showAllGroupsCTA"
          :text="$t('all-groups')"
          :clickFunction="openAllGroupsSaboteurVotes"
          backBg="#000000"
          frontBg="#676767"
          textColor="#ffc642"
          :button-width="isMobile ? '70px' : isTablet ? '72px' : '86px'"
        />
      </div>
    </div>

    <div :class="$pgCTStyle.bodyContainer">
      <div :class="$style.textContainer" v-for="(player, index) in saboteurVotes" :key="player.id">
        <!-- TOP -->
        <div :class="$style.textTopContainer" @click="toggleExpandPlayer(player.id)">
          <div :class="$style.textTopLeftContainer">
            <div :class="$style.playerRank">{{ index + 1 }}</div>

            <img :class="$style.playerAvatar" :src="player.avatar ?? defaultAvatar" alt="player" />

            <div :class="$style.playerNameRow">
              <span :class="$style.playerNameText">{{ player.username ? player.username : "Player" }}</span>
              <span v-if="saboteur?.id == player.id" :class="$style.saboteurChip">{{ $t("saboteur") }}</span>
            </div>
          </div>

          <div :class="$style.textTopRightContainer">
            <!-- Always show 0 votes -->
            <div :class="$style.textVotes">{{ (player?.votes ?? 0) }}, {{ $t("votes") }}</div>

            <div
              :class="$style.dropDownIconContainer"
              @click.stop="toggleExpandPlayer(player.id)"
            >
              <img
                :src="dropDownIcon"
                alt="icon"
                :class="[$style.dropDownIcon, expandStates[player.id] ? $style.iconRotated : '']"
              />
            </div>
          </div>
        </div>

        <!-- BOTTOM (dropdown) -->
        <transition
          @before-enter="beforeEnter"
          @enter="enter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @leave="leave"
          @after-leave="afterLeave"
        >
        <div v-if="expandStates[player.id]" :class="$style.textBottomContainer">
          <template v-if="(player.voters || []).length">
            <div v-for="v in (player.voters || [])" :key="v.id" :class="$style.voterRow">
              <img :src="v.avatar ?? defaultAvatar" :class="$style.voterAvatar" />
              <div :class="$style.voterName">{{ v.username }}</div>
            </div>
          </template>

          <template v-else>
            <div :class="$style.noVotersText">No votes yet.</div>
          </template>
        </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import styles from "@/css/SaboteurVotesBox.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import { defaultAvatar } from "@/utils/data";
import { NOOP } from "@/utils/functions";
import useDeviceType from "@/utils/useDeviceType";
import PGHeaderActionButton from "../buttons/PGHeaderActionButton.vue";
import DropDownIcon from "@/assets/icons/down-black.svg";

const device = useDeviceType();

export default {
  components: { PGHeaderActionButton },
  name: "SaboteurVotesBox",
  props: {
    title: { type: String, required: false, default: "" },
    players: { type: Array, required: true }, 
    saboteurVotes: { type: Array, required: false, default: () => [] },
    saboteur: { type: Object, required: false, default: () => ({}) },
    openAllGroupsSaboteurVotes: { type: Function, required: false, default: NOOP },
    isHost: { type: Boolean, required: true },
    canOpenAllGroups: { type: Boolean, required: false, default: false},
  },
  data() {
    return {
      defaultAvatar,
      dropDownIcon: DropDownIcon,
      expandStates: {}, // keyed by player id (same as TextVotesBox)
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $pgCTStyle() {
      return playGameComponentsTemplateStyles;
    },
    computedTitle() {
      return this.title || this.$t("saboteur-votes-received");
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    showAllGroupsCTA() {
      return this.openAllGroupsSaboteurVotes !== NOOP && this.canOpenAllGroups;
    },
  },
  methods: {
    toggleExpandPlayer(playerId) {
      this.expandStates[playerId] = !this.expandStates[playerId];
    },

    // SAME expand animation as TextVotesBox
    beforeEnter(el) {
      el.style.height = "0";
      el.style.opacity = "0";
    },
    enter(el, done) {
      const height = el.scrollHeight;
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.height = height + "px";
      el.style.opacity = "1";
      setTimeout(() => {
        el.style.height = "auto";
        done();
      }, 300);
    },
    afterEnter(el) {
      el.style.height = "auto";
    },
    beforeLeave(el) {
      el.style.height = el.scrollHeight + "px";
      el.style.opacity = "1";
    },
    leave(el, done) {
      el.style.transition = "height 0.3s ease, opacity 0.3s ease";
      el.style.height = "0";
      el.style.opacity = "0";
      setTimeout(() => done(), 300);
    },
    afterLeave(el) {
      el.style.height = "auto";
    },
  },
  mounted() {
    // initialize all expand states to false
    (this.saboteurVotes || []).forEach((p) => {
      this.expandStates[p.id] = false;
    });
  },
  watch: {
    // if saboteurVotes refreshes from store, keep expandStates safe
    saboteurVotes: {
      deep: true,
      handler(newVal) {
        (newVal || []).forEach((p) => {
          if (this.expandStates[p.id] === undefined) this.expandStates[p.id] = false;
        });
      },
    },
  },
};
</script>

<style scoped></style>
